export const FEATURES = [
  {
    title: '500+ Children Educated',
    sub: 'Quality schooling and learning materials for underprivileged children across rural India.',
    path: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2',
    circle: { cx: 9, cy: 7, r: 4 },
    extraPaths: ['M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  },
  {
    title: '12 Schools Supported',
    sub: 'Infrastructure, books, and resources provided to rural and semi-urban schools.',
    path: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
    polyline: [9, 22, 9, 12, 15, 12, 15, 22],
  },
  {
    title: '100% Transparent Giving',
    sub: 'Every rupee tracked — full accountability reports published quarterly.',
    polyline: [9, 11, 12, 14, 22, 4],
    extraPaths: ['M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'],
  },
]

export const PANEL_STATS = [
  { num: '500+', label: 'Children' },
  { num: '12', label: 'Schools' },
  { num: '100%', label: 'Transparent' },
]
